import React from "react";
import { ORGANIZATION_STATUSES, TRANSLATED_API_KEY_STATUSES, TRANSLATED_ARCHIVE_SERVICE_STATUSES, TRANSLATED_ORGANIZATION_STATUSES, USER_STATUSES } from "../../../../config/constants";
import { DezactivateArchiveService } from "./actionButtons/DezactivateArchiveService";
import { ReactivateArchiveService } from "./actionButtons/ReactivateArchiveService";
import { ViewOrganization } from "./actionButtons/ViewOrganization";
import { ToggleKioskAccess } from "./actionButtons/ToggleKioskAccess";
import { LinkResource } from "components/shared/LinkResource";
import { ROUTE_CLIENT_ORGANIZATIONS_VIEW, ROUTE_CLIENT_USER_VIEW } from "../../../../config/routes";
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';

function TableRow(props) {
  const { organization, index } = props;
  const { userId: currentUserId } = useParams();

  if (! organization) {
    return null;
  }

  return (
    <tr>
      <td>
        {
          organization?.id && organization?.status === ORGANIZATION_STATUSES.CREATED ?
          <LinkResource
            displayText={organization.name}
            resourceLink={ROUTE_CLIENT_ORGANIZATIONS_VIEW}
            resourceParamId={{':organizationId': organization.id}}
          /> :
          <>{organization.name} (<FormattedMessage id="components.pages.organizations.table.tableRow.organization_deleted" />)</>
        }
      </td>
      <td>{organization.neo_id && organization.neo_id}</td>
      <td>{organization.cui}</td>
      <td>{organization.registry_no && organization.registry_no}</td>
      <td>
        {
          organization.owner?.status === USER_STATUSES.ACTIVE ? (
            // If we're on the user's page, don't show a link to the same user
            currentUserId && currentUserId === organization.owner.id ? (
              <span>{organization.owner.first_name && organization.owner.last_name && `${organization.owner.first_name} ${organization.owner.last_name}`}</span>
            ) : (
              <LinkResource
                displayText={organization.owner.first_name && organization.owner.last_name && `${organization.owner.first_name} ${organization.owner.last_name}`}
                resourceLink={ROUTE_CLIENT_USER_VIEW}
                resourceParamId={{':userId': organization.owner.id}}
              />
            )
          ) : (
            <FormattedMessage id="components.pages.organizations.table.tableRow.user_deleted" />
          )
        }
      </td>
      <td>{organization.phone}</td>
      <td>{organization.city}</td>
      <td>{organization.county}</td>
      <td>{organization.country}</td>
      <td>{TRANSLATED_ORGANIZATION_STATUSES[organization.status]}</td>
      <td>{TRANSLATED_API_KEY_STATUSES[organization.api_key_status]}</td>
      <td>{TRANSLATED_ARCHIVE_SERVICE_STATUSES[organization.archive_service_setting?.status]}</td>
      <td>
        <ToggleKioskAccess
          organization={organization}
          index={index}
          actionCallback={() => props.actionCallback( true )}
        />
      </td>
      <td className="w-10">
        <ViewOrganization
          organization={organization}
          index={index}
          showIcon={true}
          actionCallback={() => props.actionCallback( true )}
        />
        <DezactivateArchiveService
          archiveServiceSetting={organization.archive_service_setting}
          index={index}
          showIcon={true}
          actionCallback={() => props.actionCallback( true )}
        />
        <ReactivateArchiveService
          archiveServiceSetting={organization.archive_service_setting}
          index={index}
          showIcon={true}
          actionCallback={() => props.actionCallback( true )}
        />
      </td>
    </tr>
  );
}

TableRow.defaultProps = {
  user: null,
};

export { TableRow };
